import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoxWithTitle, Checkbox } from '../../../../components/common';
import { updateTermsAndConditions } from '../../../../redux/actions/ReferralActions';
import { getTermsAndConditions } from '../../../../redux/reducers/ReferralReducer';
import StepsFooter from './StepsFooter';
import ReferralService from '../../../../services/ReferralService';

const TermsAndConditions = (props) => {
  const { t, hasPrevious, handlePrevStep, lastStep, activeStep, updateTermsAndConditions, termsAndConditions, create, fileName } = props;
  const { acceptedCommercialAgreement, acceptedFundsDeclaration } = termsAndConditions;
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = (values, actions) => {
    updateTermsAndConditions(values);
    create();
  };
  const getValidationSchema = () => {
    return Yup.object().shape({
      acceptedFundsDeclaration: Yup.bool().oneOf([true], t('validationTermsAndConditions')).required(t('validationRequired')),
      acceptedCommercialAgreement: Yup.bool().oneOf([true], t('validationTermsAndConditions')).required(t('validationRequired')),
    });
  };
  const footerProps = {
    hasPrevious,
    handlePrevStep,
    lastStep,
    activeStep,
    t,
  };

  const initialValues = {
    acceptedFundsDeclaration: false,
    acceptedCommercialAgreement: false,
  };

  const handleChangeCheckValue = (value) => {
    updateTermsAndConditions({
      ...termsAndConditions,
      ...value,
    });
  };

  return (
    <Formik
      onSubmit={(values) => {
        handleSubmit(values);
      }}
      values
      enableReinitialize
      validationSchema={getValidationSchema}
      validateOnChange
      initialValues={initialValues}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-10">
              <BoxWithTitle title={t('titleDeclarationOfFunds')}>
                <div className="row mx-2">
                  <div className="scroll-box-container">
                    <div className="scroll-box px-3 py-2 bg-light rounded">
                      <p className="font-weight-bold">{t('titleDeclarationOfFunds')}</p>
                      <span>{t('acceptedFundsDeclaration')}</span>
                    </div>
                    <div className="pr-3 mt-3">
                      <div className="form-group form-item">
                        <Field
                          label={t('labelFundsDeclarationInstruction')}
                          name="acceptedFundsDeclaration"
                          component={Checkbox}
                          checked={acceptedFundsDeclaration}
                          handleChange={() => {
                            handleChangeCheckValue({
                              acceptedFundsDeclaration: !acceptedFundsDeclaration,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </BoxWithTitle>
              <BoxWithTitle title={t('titleTermsAndConditions')}>
                <div className="pr-3 mt-3">
                  <div className="pr-3 mt-3">
                    <div className="form-group form-item">
                      <span
                        className="file-link"
                        target="_blank"
                        onClick={() => {
                          ReferralService.downloadFileTC(setLoading, fileName);
                        }}
                      >
                        {t('linkTC')}
                      </span>
                      {isLoading && <FontAwesomeIcon icon="spinner" size="lg" spin className="mx-2" />}
                    </div>
                  </div>
                  <div className="form-group form-item">
                    <Field
                      label={t('labelTermsAndConditionInstruction')}
                      name="acceptedCommercialAgreement"
                      component={Checkbox}
                      value={acceptedCommercialAgreement}
                      handleChange={() => {
                        handleChangeCheckValue({
                          acceptedCommercialAgreement: !acceptedCommercialAgreement,
                        });
                      }}
                    />
                  </div>
                </div>
              </BoxWithTitle>
            </div>
            <div className="col-sm-12 col-md-10" />
          </div>
          <StepsFooter {...footerProps} isSubmitting={isSubmitting} checkFD={acceptedFundsDeclaration} checkTC={acceptedCommercialAgreement} />
        </Form>
      )}
    </Formik>
  );
};
const mapStateToProps = (state) => {
  return {
    termsAndConditions: getTermsAndConditions(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateTermsAndConditions,
    },
    dispatch
  );
export default compose(withNamespaces(), connect(mapStateToProps, mapDispatchToProps))(TermsAndConditions);
